import ldUniq from 'lodash/uniq';
import { FilterResponseAPI } from '../../external/StoreFilterApi';
import { StoreInfo } from '../../external/StoresApi';
import { FilterItem } from '../../redux/reducers/StoreFilterReducer';
import { AgencyInfo } from '../../redux/reducers/StoreSelectorReducer';

// 店舗フィルタ取得APIのレスポンスをフォーマットする
const formatResponse = (filterStoreCds: FilterResponseAPI[], agencies: StoreInfo[] | AgencyInfo[]): FilterItem[] => {
  const formatFilter = filterStoreCds.map((item) => ({
    filterName: item.filterName,
    filterID: item.filterId,
    ordcstmCdList: item.storeFilterVariableInfos.map((e) => e.ordcstmCd),
    sortOrder: item.sortOrder,
  }));

  let firstActiveIndex = -1;
  // 担当外になった店舗の確認
  return formatFilter.map((item, i) => {
    const { exist, formatOrdcstmCdList } = item.ordcstmCdList.reduce(
      (acc, curr) => {
        const findIndex = agencies.findIndex((agency: StoreInfo | AgencyInfo) => agency.agencyCd === curr);
        if (findIndex === -1) return { ...acc, exist: false };
        return {
          ...acc,
          formatOrdcstmCdList: [...acc.formatOrdcstmCdList, curr],
        };
      },
      {
        exist: true,
        formatOrdcstmCdList: [],
      }
    );

    // 店舗フィルタ初期表示処理
    if (exist && firstActiveIndex === -1) {
      firstActiveIndex = i;
    }
    return { ...item, isExist: exist, checked: false, isActive: i === firstActiveIndex, ordcstmCdList: formatOrdcstmCdList };
  });
};

export const getDuplicateStoreIndexes = (
  selectedStoreIndexes: string[],
  originalAgencies?: {
    [key: string]: AgencyInfo;
  },
  groupAgencies?: {
    [key: string]: AgencyInfo[];
  }
): string[] => {
  const selectedAgenyCds = selectedStoreIndexes.map((value: string) => {
    return originalAgencies?.[value]?.agencyCd || '';
  });

  return selectedAgenyCds.reduce((acc: string[], agencyCd: string): string[] => {
    const duplicateStores = groupAgencies?.[agencyCd] || [];
    duplicateStores.forEach((store) => {
      if (!store.index) return;
      acc.push(store.index);
    });
    return acc;
  }, []);
};

export const countActiveStores = (ordcstmCdList: string[], isAgencyModule: boolean, groupAgencies?: { [key: string]: AgencyInfo[] }) => {
  if (isAgencyModule) return ordcstmCdList.length;

  return ldUniq(ordcstmCdList).reduce((acc, agencyCd) => {
    const agencyCdList = groupAgencies?.[agencyCd] || [];
    return acc + agencyCdList.length;
  }, 0);
};

export { formatResponse };
